import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import { loadLottie } from "../lib/async-bundles";

import * as eventKeys from '../lib/events';

const DELAY = 1000;

export default el => {

    const $el = $(el);
    let lottie;
    let animation;
    let isPaused = false;

    let playTimeout;

    const delayPlay = () => {
        if (playTimeout) {
            return;
        }
        playTimeout = setTimeout(() => {
            clearTimeout(playTimeout);
            playTimeout = null;
            if (!Viewport.visible(el)) {
                return;
            }
            isPaused = false;
            animation.play();
        }, DELAY);
    };

    const onDataReady = () => {
        $el.addClass('js-inited');
        delayPlay();
    };

    const createAnimation = () => {
        if (!lottie) {
            console.warn('Attempted to start animation before lottie loaded');
        }
        animation = lottie.loadAnimation({
            container: $el.find('[data-anim]').get(0),
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: '/assets/json/Kistefos_loop_152x152.json'
        });
        animation.addEventListener('data_ready', onDataReady);
    };

    const playAnimation = () => {
        if (animation === undefined) {
            if (lottie === undefined) {
                animation = null;
                lottie = null;
                loadLottie(runtime => {
                    lottie = runtime;
                    createAnimation();
                });
                return;
            }
            createAnimation();
            return;
        }
        if (!isPaused || !animation) {
            return;
        }
        delayPlay();
    };

    const pauseAnimation = () => {
        if (playTimeout) {
            clearTimeout(playTimeout);
            playTimeout = null;
        }
        if (!animation) {
            return;
        }
        isPaused = true;
        animation.pause();
    };

    const onScroll = () => {
        const isVisible = Viewport.visible(el);
        if (isVisible) {
            playAnimation();
        } else {
            pauseAnimation();
        }
    };

    const onResize = () => {
        onScroll();
    };

    const onInfoPanelActivated = () => {
        playAnimation();
    };

    const init = () => {
        Viewport.on('scroll', onScroll);
        Viewport.on('resize', onResize);
        Dispatch.on(eventKeys.INFORMATION_PANEL_ACTIVATED, onInfoPanelActivated, true);
        onScroll();
    };

    const destroy = () => {
        if (animation) {
            animation.removeEventListener('data_ready', onDataReady);
            animation.destroy();
            animation = null;
        }
        Viewport.off('scroll', onScroll);
        Viewport.off('resize', onResize);
        Dispatch.off(eventKeys.INFORMATION_PANEL_ACTIVATED, onInfoPanelActivated);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/SymbolAnimation.js